@use "~theme/typography";

.card {
  padding: 28px;
  margin: 0;
  max-width: unset;
}

.headerContainer {
  position: relative;
}

.header {
  @include typography.heading4;
  color: var(--blue-01);
  text-transform: uppercase;
  display: flex;
  justify-content: space-between;
}

.ratio {
  white-space: nowrap;
}

.headerBubble {
  position: absolute;
  bottom: 12px;
  right: -16px;
}

.progressBar {
  margin-top: 12px;
  margin-bottom: 30px;
}

.section {
  border-top: 1px solid var(--blue-01-at-30);
  padding-top: 32px;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.task {
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: unset;
  }
}

.taskTitle {
  @include typography.body;
  display: flex;
  align-items: flex-start;
  color: var(--black);
  margin-bottom: 4px;

  > img {
    margin-right: 6px;
    width: 20px;
    visibility: hidden;
  }
}

.taskTitleCompleted {
  color: var(--black-at-75);

  > img {
    visibility: visible;
  }
}

.taskDescription {
  @include typography.caption;
  color: var(--black-at-75);
  padding-left: 26px; // to account for space given to checkmark in the title
}